export default "__VITE_ASSET__BTdRWl2E__"